import React, { useState, useEffect, useRef } from "react";
import { FaSearch } from "react-icons/fa";

interface SearchProps {
  onSearchResults?: (query: string) => void;
  initialQuery?: string;
}

const Search: React.FC<SearchProps> = ({ onSearchResults, initialQuery }) => {
  const [query, setQuery] = useState(initialQuery || "");
  const [open, setOpen] = useState(false); // Show/hide input bar toggle

  const handleIconClick = () => {
    // 🔥 If bar already open and query present → search + close
    if (open && query.trim() !== "") {
      onSearchResults?.(query.trim());
      setOpen(false);
      setQuery("");
    } else {
      setOpen(!open); // 🔄 Toggle open/close
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearchResults?.(query.trim());
  };

  return (
    <div
      className="d-flex align-items-center position-relative"
      style={{ height: "34px" }}
    >

      {/* 🔍 Search Icon */}
      <FaSearch
        onClick={handleIconClick}
        style={{
          cursor: "pointer",
          color: "#28a745",
          fontSize: "18px",
          transition: "0.3s",
          marginRight: open ? "6px" : "0",
        }}
      />

      {/* 🔄 Sliding Search Input */}
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Search products..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          style={{
            width: open ? "180px" : "0px",
            opacity: open ? 1 : 0,
            transition: "0.3s ease",
            padding: open ? "5px 10px" : "0px",
            border: open ? "1px solid #ccc" : "0px",
            fontSize: "14px",
            borderRadius: "4px",
            overflow: "hidden",
          }}
        />
      </form>
    </div>
  );
};

export default Search;

